import { render, staticRenderFns } from "./Amap.vue?vue&type=template&id=51d6f6de&scoped=true"
import script from "./Amap.vue?vue&type=script&lang=js"
export * from "./Amap.vue?vue&type=script&lang=js"
import style0 from "./Amap.vue?vue&type=style&index=0&id=51d6f6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6f6de",
  null
  
)

export default component.exports